import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Company from '../../../../../model/company/company';
import { SignCompany } from '../../../../../model/sign/sign-company';
import { SignParticipatingCompany } from '../../../../../model/sign/sign-participating-company';

@Component({
  selector: 'participating-company-edit',
  templateUrl: './participating-company-edit.component.html',
  styleUrls: ['./participating-company-edit.component.scss']
})
export class ParticipatingCompanyEditComponent implements OnInit {
  @Input()
  participatingCompany: SignParticipatingCompany;

  @Output()
  itemRemoved = new EventEmitter();

  isEditing: boolean;

  ngOnInit() {
    if (this.participatingCompany.company == null) {
      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
  }

  onCompanyIsSelected(company: Company): void {
    const signCompany = new SignCompany();
    signCompany.id = company.id;
    signCompany.regularName = company.regularName;

    this.participatingCompany.company = signCompany;

    this.stopEditing();
  }

  startEditing(): void {
    this.participatingCompany.localCompany = new Company();
    this.isEditing = true;
  }

  stopEditing(): void {
    this.isEditing = false;
    if (this.participatingCompany.company == null) {
      this.remove();
    }
  }

  remove(): void {
    this.itemRemoved.emit();
  }
}
